export const ROUTE_DETAILS_REQUEST = "ROUTE_DETAILS_REQUEST";
export const ROUTE_DETAILS_SUCCESS = "ROUTE_DETAILS_SUCCESS";
export const ROUTE_DETAILS_FAIL= "ROUTE_DETAILS_FAIL";
export const ROUTE_DETAILS_RESET= "ROUTE_DETAILS_RESET";

export const STOP_DETAILS_REQUEST = "STOP_DETAILS_REQUEST";
export const STOP_DETAILS_SUCCESS = "STOP_DETAILS_SUCCESS";
export const STOP_DETAILS_FAIL= "STOP_DETAILS_FAIL";
export const STOP_DETAILS_RESET= "STOP_DETAILS_RESET";

export const ROUTE_NAMES_REQUEST = "ROUTE_NAMES_REQUEST";
export const ROUTE_NAMES_SUCCESS = "ROUTE_NAMES_SUCCESS";
export const ROUTE_NAMES_FAIL= "ROUTE_NAMES_FAIL";
export const ROUTE_NAMES_RESET= "ROUTE_NAMES_RESET";